"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FaqItem {
  question: string;
  answer: string;
}

interface BlogFAQProps {
  items?: FaqItem[];
}

// Renders the post's frontmatter FAQ as an accordion. Bound from post.faq in
// the blog [slug] page so MDX files use <BlogFAQ /> with no props. The same
// frontmatter still powers the FAQPage JSON-LD, so there is one source of truth.
// The visible heading comes from the "## Frequently Asked Questions" markdown
// heading in the MDX (which also feeds the table of contents), so this component
// renders only the accordion to avoid a duplicate heading.
export default function BlogFAQ({ items }: BlogFAQProps) {
  if (!items?.length) return null;

  return (
    <section className="w-full my-2">
      <Accordion
        type="single"
        collapsible
        className="rounded-2xl border border-line bg-panel px-5 sm:px-6"
      >
        {items.map((item, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            className="border-b border-line last:border-b-0"
          >
            <AccordionTrigger className="text-left text-base font-semibold text-white hover:no-underline py-5 gap-4">
              {item.question}
            </AccordionTrigger>
            <AccordionContent className="text-base text-zinc-400 leading-relaxed">
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
